import { render, staticRenderFns } from "./industrial-&-chemical-solutions.vue?vue&type=template&id=3e8b70c2&"
import script from "./industrial-&-chemical-solutions.vue?vue&type=script&lang=js&"
export * from "./industrial-&-chemical-solutions.vue?vue&type=script&lang=js&"
import style0 from "./industrial-&-chemical-solutions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports